module.exports = __webpack_public_path__ + "static/img/cointelegraph-logo.e16b8ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cointelegraph-logo.jpg
// module id = gTDo
// module chunks = 1